import CounterList from './common/CounterList';

const PEOPLE = [
  { key: 'groom', label: '신랑', icon: 'ri-user-line' },
  { key: 'bride', label: '신부', icon: 'ri-women-line' },
  { key: 'mother', label: '어머니', icon: 'ri-parent-line' },
  { key: 'father', label: '아버지', icon: 'ri-parent-line' },
  { key: 'friend', label: '친구 / 지인', icon: 'ri-team-line' },
];

interface StepPeopleProps {
  value: Record<string, number>;
  onChange: (val: Record<string, number>) => void;
}

export default function StepPeople({ value, onChange }: StepPeopleProps) {
  return <CounterList items={PEOPLE} value={value} onChange={onChange} />;
}
